<app-data-selector
  label="Impressora Padrão"
  [repository]="printerRepository"
  display="printerNameHub"
  [value]="defaultReceiptPrinter"
  (valueChange)="onPrinterSelected($event)"
></app-data-selector>
